import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ThkVideoPlayerComponent } from '../learning-lab';

@Component({
  selector: 'app-formly-videoplayer',
  standalone: true,
  imports: [NgIf, ThkVideoPlayerComponent],
  template: `
    <div class="preview min-h-24 overflow-hidden rounded-lg">
      <ng-container *ngIf="sources$">
        <app-thk-video-player
          [sources$]="sources$"
          [settingsButton]="false"
          [relatedMenu]="false"
          [qualityMenu]="false"
          [buttonRewind]="false"
          [autoplay]="false"
          [singlePlayer]="false"
          [theaterButton]="false"
          [enableHotkey]="enableHotkey"
          [poster]="''"
          [aspectRatio]="aspectRatio"
        >
        </app-thk-video-player>
      </ng-container>
    </div>
  `,
})
export class FormlyFileVideoPlayerComponent {
  @Input() sources$ = new BehaviorSubject<any>({});
  @Input() enableHotkey: boolean = false;
  @Input() aspectRatio: string = '7:4';
}
